export default function HomeMarketing() {
  return <>

<section className="social" id="social" aria-labelledby="social-title">
<span id="about" className="home-anchor" />
<div className="social__stage">
<div className="social__bg" aria-hidden="true"></div>
<div className="wrap social__inner">
<div className="social__intro">
<span className="eyebrow">{"More than a ticket"}</span>
<h2 className="h2" id="social-title" data-split>{"Don't just go."}<br /><em>{"Go together."}</em></h2>
<div className="steps" id="steps">
<div className="step is-active" data-step="0">
<span className="step__num">{"01"}</span>
<div className="step__title">{"Discover what's on"}</div>
<div className="step__text"><span>{"Every event in the city, filtered by day, vibe and distance. Save the ones you like."}</span></div>
<div className="step__bar"><i></i></div>
</div>
<div className="step is-active" data-step="1">
<span className="step__num">{"02"}</span>
<div className="step__title">{"Book in seconds"}</div>
<div className="step__text"><span>{"Choose a ticket and complete checkout with CityMoshi or the ticket provider. CityMoshi tickets include an in-app QR code for entry."}</span></div>
<div className="step__bar"><i></i></div>
</div>
<div className="step is-active" data-step="2">
<span className="step__num">{"03"}</span>
<div className="step__title">{"Share the night"}</div>
<div className="step__text"><span>{"Post moments, watch stories from the crowd and see which friends are going."}</span></div>
<div className="step__bar"><i></i></div>
</div>
<div className="step is-active" data-step="3">
<span className="step__num">{"04"}</span>
<div className="step__title">{"Message & follow"}</div>
<div className="step__text"><span>{"DM friends, send them events and follow the organizers you love so you never miss a drop."}</span></div>
<div className="step__bar"><i></i></div>
</div>
</div>
</div>
<div className="social__phone">
<svg className="social__halo" viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="46" fill="none" stroke="rgba(255,255,255,.07)" strokeWidth=".25"></circle><circle cx="50" cy="50" r="38" fill="none" stroke="rgba(255,255,255,.05)" strokeWidth=".25" strokeDasharray=".6 1.6"></circle><path d="M96 50A46 46 0 1 1 50 4" fill="none" stroke="rgba(166,66,92,.55)" strokeWidth=".4"></path></svg>
<div className="device">
<span className="device__btn device__btn--action"></span>
<span className="device__btn device__btn--volup"></span>
<span className="device__btn device__btn--voldn"></span>
<span className="device__btn device__btn--power"></span>
<div className="device__body">
<div className="device__screen">
<div className="device__island"></div>
<div className="screen is-active" data-screen="0"><img src="/homepage/img/screen-events.webp" alt="CityMoshi app: events list" width="440" height="963" /></div>
<div className="screen" data-screen="1"><img src="/homepage/img/screen-details.webp" alt="CityMoshi app: event details with See Tickets button" width="440" height="963" /></div>
<div className="screen" data-screen="2">
<div className="sbar"><span>{"9:41"}</span><span className="sbar__r"><svg viewBox="0 0 18 12"><rect x="0" y="8" width="3" height="4" rx="1" fill="#fff"></rect><rect x="5" y="5.5" width="3" height="6.5" rx="1" fill="#fff"></rect><rect x="10" y="3" width="3" height="9" rx="1" fill="#fff"></rect><rect x="15" y="0" width="3" height="12" rx="1" fill="#fff"></rect></svg><svg viewBox="0 0 16 12"><path d="M8 11.5 5.6 9a3.4 3.4 0 0 1 4.8 0L8 11.5Zm-4.2-4.3L2.3 5.7a8 8 0 0 1 11.4 0l-1.5 1.5a5.9 5.9 0 0 0-8.4 0ZM.4 3.8 0 3.4a11.3 11.3 0 0 1 16 0l-.4.4-1.1 1.1a9.7 9.7 0 0 0-13 0L.4 3.8Z" fill="#fff"></path></svg><i className="batt"></i></span></div>
<div className="feed">
<div className="feed__head"><b>{"Discover"}</b><div className="feed__icons"><i><svg><use href="#i-map"></use></svg></i><i><svg><use href="#i-bell"></use></svg></i></div></div>
<div className="feed__stories">
<span className="story"><i><img src="/homepage/img/stage-crowd-sm.webp" alt="" /></i>{"Kigali Fusion"}</span>
<span className="story"><i><img src="/homepage/img/club-blue-sm.webp" alt="" /></i>{"Timeless"}</span>
<span className="story"><i><img src="/homepage/img/park-party-sm.webp" alt="" /></i>{"Jazzy Lit"}</span>
<span className="story"><i><img src="/homepage/img/cheers-sm.webp" alt="" /></i>{"Anderes"}</span>
<span className="story is-seen"><i><img src="/homepage/img/headphones-sm.webp" alt="" /></i>{"Tayo's"}</span>
</div>
<div className="post">
<div className="post__head"><img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&auto=format&fit=crop&q=70" alt="" /><div><b>{"Kevin Munyaneza"}</b><small>{"2h ago"}</small></div></div>
<p>{"This was so much fun, I'm going again! The atmosphere in Kimihurura was unbelievable \ud83d\udd25"}</p>
<div className="post__media"><img src="/homepage/img/crowd-selfie-sm.webp" alt="" /><img src="/homepage/img/dancer-sm.webp" alt="" /></div>
<div className="post__loc"><svg><use href="#i-pin"></use></svg>{"Kivu Noir Gala @ Kimihurura"}</div>
<div className="post__acts"><span className="liked"><svg><use href="#i-heart"></use></svg>{"184"}</span><span><svg><use href="#i-chat"></use></svg>{"24"}</span><span><svg><use href="#i-send"></use></svg></span></div>
</div>
<div className="post">
<div className="post__head"><img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&auto=format&fit=crop&q=70" alt="" /><div><b>{"Aline Umutoni"}</b><small>{"45m ago"}</small></div></div>
<p>{"The live sax session right now is pure magic \u2728 Don't miss this rooftop vibe!"}</p>
</div>
</div>
<div className="tabbar"><span><svg><use href="#i-home"></use></svg>{"Home"}</span><span className="on"><svg><use href="#i-feed"></use></svg>{"Feed"}</span><span className="create"><svg><use href="#i-plus"></use></svg></span><span><svg><use href="#i-chat"></use></svg>{"Messages"}</span><span><svg><use href="#i-user"></use></svg>{"Profile"}</span></div>
</div>
<div className="screen" data-screen="3">
<div className="sbar"><span>{"9:41"}</span><span className="sbar__r"><svg viewBox="0 0 18 12"><rect x="0" y="8" width="3" height="4" rx="1" fill="#fff"></rect><rect x="5" y="5.5" width="3" height="6.5" rx="1" fill="#fff"></rect><rect x="10" y="3" width="3" height="9" rx="1" fill="#fff"></rect><rect x="15" y="0" width="3" height="12" rx="1" fill="#fff"></rect></svg><svg viewBox="0 0 16 12"><path d="M8 11.5 5.6 9a3.4 3.4 0 0 1 4.8 0L8 11.5Zm-4.2-4.3L2.3 5.7a8 8 0 0 1 11.4 0l-1.5 1.5a5.9 5.9 0 0 0-8.4 0ZM.4 3.8 0 3.4a11.3 11.3 0 0 1 16 0l-.4.4-1.1 1.1a9.7 9.7 0 0 0-13 0L.4 3.8Z" fill="#fff"></path></svg><i className="batt"></i></span></div>
<div className="chat">
<div className="chat__head"><svg className="back"><use href="#i-chev-l"></use></svg><img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&auto=format&fit=crop&q=70" alt="" /><div><b>{"Aline Umutoni"}</b><small>{"Active now"}</small></div></div>
<div className="chat__body">
<span className="chat__day">{"Today"}</span>
<div className="msg them">{"Are you going out tonight? \ud83d\udc40"}</div>
<div className="msg me">{"Yesss, just got 2 tickets \ud83c\udf9f\ufe0f"}</div>
<div className="msg-card"><img src="/homepage/img/flyer-jazz.webp" alt="" data-story="img" /><div><small data-story="cat">{"Live Music"}</small><b data-story="name">{"Kigali Jazz Junction"}</b><span data-story="when">{"Tonight \u00b7 6:00 PM"}</span></div></div>
<div className="msg them">{"Meet at the gate at 6? Kevin's coming too"}</div>
<div className="msg me">{"Deal \ud83d\udd25"}</div>
<div className="chat__typing"><img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=60&auto=format&fit=crop&q=70" alt="" />{"Aline is typing"}<span className="typing"><i></i><i></i><i></i></span></div>
</div>
<div className="chat__input"><span className="round"><svg><use href="#i-plus"></use></svg></span><span className="field">{"Type here\u2026"}</span><span className="round"><svg><use href="#i-send"></use></svg></span></div>
</div>
</div>
<div className="device__glare"></div>
</div>
</div>
</div>
</div>
</div>
</div>
</section>

<section className="section organizers" id="organizers" aria-labelledby="org-title">
<span id="features" className="home-anchor" /><span id="highlights" className="home-anchor" />
<div className="wrap">
<div className="section-head">
<div className="section-head__text">
<span className="eyebrow">{"For organizers"}</span>
<h2 className="h2" id="org-title" data-split>{"Hosting something?"}<br /><em>{"Fill the room."}</em></h2>
</div>
<div className="org-head__aside" data-reveal>
<p className="lede">{"One dashboard for tickets, sales, agents, check-in, payouts and community."}</p>
<a className="btn btn--primary btn--lg" href="https://dashboard.citymoshi.com" target="_blank" rel="noreferrer" data-magnetic>
<span className="btn__label"><span data-text="Claim your account">{"Claim your account"}</span></span><svg className="arrow"><use href="#i-arrow"></use></svg>
</a>
</div>
</div>
<div className="dash-stage">
<div className="macbook" id="macbook">
<div className="macbook__lid">
<div className="macbook__screen">
<span className="macbook__notch" aria-hidden="true"></span>
<img className="macbook__shot" src="/homepage/img/dashboard.webp" srcSet="/homepage/img/dashboard-sm.webp 900w, /homepage/img/dashboard.webp 1440w" sizes="(max-width: 1200px) 90vw, 1040px" width="1440" height="1180" loading="lazy" decoding="async" alt="CityMoshi organizer dashboard on a laptop: live events, tickets sold, revenue and audience, a tickets-sold chart and upcoming events" />
<span className="macbook__glare" aria-hidden="true"></span>
</div>
</div>
<div className="macbook__base" aria-hidden="true"><span className="macbook__groove"></span></div>
</div>
</div>
<p className="dash-caption">{"The CityMoshi organizer dashboard. Figures shown are sample data."}</p>
<div className="feats">
<div className="feats__head">
<h3 className="feats__title" data-split>{"Everything you need to "}<em>{"run the night."}</em></h3>
<p className="lede" data-reveal>{"For promoters, venues and festivals in Rwanda, Uganda, Kenya, Tanzania and Ethiopia."}</p>
<a className="btn btn--ghost" href="https://dashboard.citymoshi.com" target="_blank" rel="noreferrer" data-reveal>{"Open the dashboard"}<svg className="arrow"><use href="#i-arrow"></use></svg></a>
</div>
<ol className="flist">
<li className="frow">
<span className="frow__num">{"01"}</span>
<div className="frow__text"><h4>{"Easy payouts"}</h4><p>{"Get paid straight to MTN MoMo, Airtel Money or your bank."}</p></div>
<div className="frow__tags"><span className="tchip tchip--logo"><img src="/homepage/img/pay-momo.webp" alt="" width="18" height="18" />{"MTN MoMo"}</span><span className="tchip tchip--logo"><img src="/homepage/img/pay-airtel.webp" alt="" width="18" height="18" />{"Airtel Money"}</span><span className="tchip tchip--logo"><img src="/homepage/img/pay-bank.webp" alt="" width="18" height="18" />{"Bank"}</span></div>
</li>
<li className="frow">
<span className="frow__num">{"02"}</span>
<div className="frow__text"><h4>{"Community feed"}</h4><p>{"Share event moments and see posts from people in your community."}</p></div>
<div className="frow__tags"><span className="tchip">{"Posts"}</span><span className="tchip tchip--on">{"Event moments"}</span></div>
</li>
<li className="frow">
<span className="frow__num">{"03"}</span>
<div className="frow__text"><h4>{"Announcements"}</h4><p>{"Post updates in the app and every ticket holder gets them as a push notification."}</p></div>
<div className="frow__tags"><span className="tchip">{"In-app"}</span><span className="tchip tchip--on">{"Push notification"}</span></div>
</li>
</ol>
</div>
</div>
</section>

<section className="section download" id="download" aria-labelledby="dl-title">
<div className="wrap">
<div className="download__card" data-reveal>
<svg className="download__ring" viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="40" fill="none" stroke="rgba(255,255,255,.08)" strokeWidth=".3"></circle><circle cx="50" cy="50" r="30" fill="none" stroke="rgba(255,255,255,.06)" strokeWidth=".3" strokeDasharray="1 2"></circle><path d="M90 50A40 40 0 1 1 50 10" fill="none" stroke="rgba(166,66,92,.55)" strokeWidth=".6"></path></svg>
<div className="download__text">
<span className="eyebrow">{"Get the app"}</span>
<h2 className="h2" id="dl-title" data-split>{"Your city, in"}<br />{"your "}<em>{"pocket."}</em></h2>
<p className="lede">{"Tickets, stories, chats and every event in the city. Free on iPhone and Android."}</p>
<div className="stores">
<a className="store" href="https://apps.apple.com/us/app/citymoshi/id6560116116" target="_blank" rel="noreferrer" data-magnetic>
<svg><use href="#i-apple"></use></svg><span><small>{"Download on the"}</small><b>{"App Store"}</b></span>
</a>
<a className="store" href="https://play.google.com/store/apps/details?id=com.citymoshi.app" target="_blank" rel="noreferrer" data-magnetic>
<svg><use href="#i-play"></use></svg><span><small>{"Get it on"}</small><b>{"Google Play"}</b></span>
</a>
</div>
</div>
<div className="download__phones" aria-hidden="true">
<img src="/homepage/img/phone-feed.webp" alt="" loading="lazy" data-speed="0.1" />
<img src="/homepage/img/phone-map.webp" alt="" loading="lazy" data-speed="-0.06" />
</div>
</div>
</div>
</section>

  </>;
}
